export const MOBILE_WARNING_MESSAGE =
  "PromptLayer is currently optimized for desktops. Please visit us on your computer for the best experience.";

export const MOBILE_SCHEDULE_DEMO_BUTTON_TEXT =
  "PromptLayer is currently optimized for desktops. Please visit us on your computer for the best experience, or schedule a demo below.";
